import React, { useContext } from 'react';
import BlazeInputReactSelect from 'blaze-input-react-select';
import DealContext from './DealContext';

const AddMenu = React.forwardRef(({ children, style, className, 'aria-labelledby': labeledBy }, ref) => {
  const { quoteList, presentQuote, openQuotes, activeTabIndex } = useContext(DealContext);

  const quoteIsActive = activeTabIndex && /\d+/.test(activeTabIndex);
  const selectValue = quoteIsActive ? { value: Number(activeTabIndex), label: `Quote ${activeTabIndex}` } : undefined;
  const hasQuotes = quoteList.length > 0;

  const handleQuoteChange = (fieldName, quoteId) => {
    presentQuote(quoteId);
  };

  return (
    <div ref={ref} style={style} className={className} aria-labelledby={labeledBy}>
      {hasQuotes === true && (
        <div className="p-2" style={{ width: '250px' }}>
          <BlazeInputReactSelect
            key={activeTabIndex}
            className="react-select-container flex-grow-1"
            classNamePrefix="react-select"
            onChange={handleQuoteChange}
            controlId="quote-list"
            placeholder="Select Quote To Display"
            field={{
              name: 'quotes',
              label: '',
              options: quoteList.map(q => {
                const isOpen = openQuotes.includes(q.id);
                const label = isOpen ? (
                  <>
                    <i className="fas fa-check mr-1" style={{ color: 'var(--green-5)' }} /> Quote {q.id}
                  </>
                ) : (
                  `Quote ${q.id}`
                );
                return { label, value: q.id };
              }),
            }}
            value={selectValue}
          />
        </div>
      )}

      {children}
    </div>
  );
});

export default AddMenu;
